export default __webpack_public_path__ + "static/media/q10.3e3ba3ab.png";